import React, { useEffect, useState } from 'react'
import ContentLoader from 'react-content-loader'
import styled from 'styled-components'
import tw, { theme } from 'twin.macro'

const DesktopContainer = styled.div`
  ${tw`hidden`} 
  @media(min-width: ${theme`screens.md`}) {
    ${tw`block`}
  }
`

const MobileContainer = styled.div`
  ${tw`block`} 
  @media(min-width: ${theme`screens.md`}) {
    ${tw`hidden`}
  }
`

const ArticleCardLoader = () => {
  return (
    <>
      <DesktopArticleCardLoader />
      <MobileArticleCardLoader />
    </>
  )
}

const DesktopArticleCardLoader = () => {
  return (
    <DesktopContainer>
      <ContentLoader
        width={368}
        height={340}
        viewBox="0 0 368 340"
        backgroundColor="#F7F7F7"
        foregroundColor="#EDEDED"
      >
        {/*大圖*/}
        <rect x="0" y="0" rx="12" ry="12" width="368" height="193" />
        {/*發文者區塊 Start*/}
        <circle cx="12" cy="217" r="12" />
        <rect x="32" y="210" rx="7" ry="7" width="80" height="14" />
        <rect x="308" y="210" rx="7" ry="7" width="60" height="14" />
        {/*發文者區塊 End*/}
        {/*tag區塊 start*/}
        <rect x="0" y="241" rx="7" ry="7" width="200" height="14" />
        {/*tag區塊 end*/}
        {/*文字區塊 start*/}
        <rect x="0" y="267" rx="10" ry="10" width="368" height="20" />
        <rect x="0" y="299" rx="10" ry="10" width="240" height="20" />
        {/*文字區塊 end*/}
      </ContentLoader>
    </DesktopContainer>
  )
}

const MobileArticleCardLoader = () => {
  const [isLoadingFinish, setIsLoadingFinish] = useState(false)
  useEffect(() => {
    setIsLoadingFinish(true)
  }, [])
  if (!isLoadingFinish) return <></>

  const contentWidth = window.innerWidth - 32
  const textWidth = window.innerWidth - 32 - 92

  return (
    <MobileContainer>
      <ContentLoader
        width={contentWidth}
        height={104}
        viewBox={`0 0 ${contentWidth} 104`}
        backgroundColor="#f0f0f0"
        foregroundColor="#dedede"
      >
        {/*大圖*/}
        <rect x="0" y="0" rx="12" ry="12" width="80" height="80" />
        {/*tag區塊 start*/}
        <rect x="92" y="0" rx="6" ry="6" width="200" height="12" />
        {/*tag區塊 end*/}

        {/*文字區塊 start*/}
        <rect x="92" y="22" rx="8" ry="8" width={textWidth} height="16" />
        <rect x="92" y="42" rx="8" ry="8" width={textWidth - 90} height="16" />
        {/*文字區塊 end*/}

        {/*發文者區塊 Start*/}
        <rect x="92" y="68" rx="6" ry="6" width="68" height="12" />
        {/*發文者區塊 End*/}
      </ContentLoader>
    </MobileContainer>
  )
}

export default ArticleCardLoader
